module.exports = __webpack_public_path__ + "kenya.svg?af8f4174a65cd5214dbf5dbd73474ffd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kenya.svg
// module id = 204
// module chunks = 10